
















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class ShareModel extends Vue {
  @Prop() close: any
  @Prop({ default: {} })
  tipConfig: any
  get mpurl() {
    return this.tipConfig.appurl || require('@/assets/share-code.jpg')
  }
}
